import EntryPoint from "./components/EntryPoint";
import Users from "../users/routes";
// import Dashboard from "../dashboard/routes";
import GpsSearch from "../gpsSearch/routes";
import Inventories from "../stock/routes";
import Settings from "../settings/routes";
import Companies from '../company/routes';
import Stores from '../store/routes';
import TransmissionValidator from "../transmissionValidator/routes";
import HistoricalInfo from "../historicalInfo/routes";
import ActiveServices from "../activeServices/routes";
import GestionVehicles from "../gestionVehicles/routes";
import Reports from '../reports/routes';
import RenewalConfigs from '../renewalConfigs/routes';
import DeviceCommands from '../deviceCommands/routes';
import { activeServicesSVG } from '../shared/helpers/icons';

const tuneSVG = './assets/icons/tune.svg';

export const innerRoutes = [GpsSearch, Inventories, Users, Companies, Stores, TransmissionValidator, HistoricalInfo, ActiveServices, RenewalConfigs, GestionVehicles, Reports, DeviceCommands, Settings];

const RenovacionesGroup = {
    path: '/renovaciones',
    isGroup: true,
    availableSubMenu: true,
    icon: activeServicesSVG,
    title: { key: 'Renovaciones', plural: false },
    innerRoutes: [
        {
            path: '/activeServices/',
            icon: activeServicesSVG,
            title: { key: 'Gestión de renovaciones', plural: false },
        },
        {
            path: '/renewalConfigs/',
            icon: tuneSVG,
            title: { key: 'Configuración', plural: false },
        },
    ],
};

export const sidebarItems = [GpsSearch, Inventories, Users, Companies, Stores, TransmissionValidator, HistoricalInfo, RenovacionesGroup, GestionVehicles, Reports, DeviceCommands, Settings];

const home = {
    path: "/",
    Component: EntryPoint,
    exact: false,
    innerRoutes: [...innerRoutes]
};

export default home;
